import { render } from "./challenge.vue?vue&type=template&id=95eec02a"
import script from "./challenge.vue?vue&type=script&lang=js"
export * from "./challenge.vue?vue&type=script&lang=js"

import "./challenge.vue?vue&type=style&index=0&id=95eec02a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__